import _ from 'lodash';

import apiFront from 'common/utils/apiFront';
import { getClientIdFromCookie } from 'common/utils/gtm';
import { METHOD } from 'common/constants/HttpConstants';

import {
  DELIVERY_CUSTOM_TYPE_PERSONAL_PICKUP,
  RESERVATION_PAYMENT_TYPE
} from 'common/constants/SiteConstants';
import { setLoading, setPageData } from 'common/actions/PageActions';

export const createReservation = values => async dispatch => {
  const { size, product } = values;
  if (values) {
    dispatch(setLoading(true));
    const reservationValues = {};
    reservationValues['name'] = _.get(values, 'name', null);
    reservationValues['surname'] = _.get(values, 'surname', null);
    reservationValues['phone'] = _.get(values, 'phone', null);
    reservationValues['email'] = _.get(values, 'email', null);
    reservationValues['deliveryType'] = _.get(values, 'deliveryType', null);
    reservationValues['paymentType'] = RESERVATION_PAYMENT_TYPE;
    reservationValues['items'] = [
      {
        productId: _.get(product, 'id', null),
        sizeId: _.get(size, 'value', null),
        count: _.get(values, 'count', 1)
      }
    ];
    reservationValues['params'] = {
      2983: 1,
      cookie_client_id: getClientIdFromCookie()
    };
    const newReservation = await dispatch(
      apiFront({
        endpoint: 'reservations',
        method: METHOD.POST,
        options: {
          data: {
            reservation: {
              ...reservationValues
            }
          }
        },
        showToastr: true,
        toastrParts: {
          title: 'reservation'
        }
      })
    );
    if (!_.isEmpty(newReservation)) {
      dispatch(setPageData(true, 'reservation', 'success'));
      dispatch(setLoading(false));
    } else {
      dispatch(setLoading(false));
    }
  }
};

export const fetchPossibleDeliveries = product => async dispatch => {
  if (product) {
    const items = {};
    items['productId'] = _.get(product, 'id', null);
    const possibleDeliveries = await dispatch(
      apiFront({
        endpoint: 'possible_deliveries',
        method: METHOD.POST,
        options: {
          data: {
            customType: DELIVERY_CUSTOM_TYPE_PERSONAL_PICKUP,
            items: items
          }
        }
      })
    );
    if (possibleDeliveries) {
      dispatch(setPageData(possibleDeliveries, 'reservation', 'deliveries'));
    }
  }
};
